module.exports = __webpack_public_path__ + "static/bg06-b98f080bc705bcbd5dbab2a1946174ec.jpg";